export function PricingFixedCosts() {
  return (
    <div className="flex flex-col gap-6 p-6">
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
        Custos Fixos e Extras
      </h1>

      <div className="flex items-center justify-center min-h-96 rounded-lg border border-dashed border-gray-300 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/50">
        <div className="text-center">
          <p className="text-gray-600 dark:text-gray-400 text-sm font-medium">
            Página de Custos Fixos e Extras em construção
          </p>
        </div>
      </div>
    </div>
  )
}
